// Header background transparent on homepage
let options = {        
  threshold: 0.9,
}

function handleIntersection(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      //alert('is intersecting');
      document.querySelector('header').classList.remove('scrolled');
    } else {
      //alert('is not intersecting');
      document.querySelector('header').classList.add('scrolled');
    }
  });
}

if (!!window.IntersectionObserver) {  
  const observer = new IntersectionObserver(handleIntersection, options);
  
  observer.observe(document.querySelector('.hero-banner'));
}
